import React from 'react'
import { func, bool, string, object, node } from 'prop-types'
import classnames from 'classnames'

import Type from 'Primitive/Type'
import Icon from 'Primitive/Icon'
import SmartLink from 'Primitive/SmartLink'
import Image from 'Primitive/Image'
import Container from 'Primitive/Container'

import styles from './Navigation.module.scss'
import { useTranslation } from 'react-i18next'
import LanguageSelector from '../LanguageSelector'

const MemoImage = React.memo(Image)

const Navigation = ({
  onHideNav,
  onShowNav,
  showNav,
  siteTitle,
  hideBrandingBg,
  logo,
  id
}) => {
  const { t } = useTranslation()
  return (
    <Container
      as="nav"
      gutter
      size="wide"
      center
      className={classnames(styles.Root, showNav && styles.showNav)}
      id={id}
    >
      <h1 hidden>{siteTitle}</h1>
      <div className={styles.Branding}>
        <SmartLink to="/">
          <MemoImage
            image={logo}
            className={styles.Logo}
            alt={siteTitle}
            loading="eager"
          />
        </SmartLink>
      </div>
      {/* <LanguageSelector showNav={showNav} linkWrapperClass={styles.NavLink} /> */}
      <div className={styles.Links}>
        <LinkWrapper to="/#contact" className={styles.NavLink}>
          {t('navigation.contact')}
        </LinkWrapper>
        <LinkWrapper className={styles.NavLink} to="/about/">
          {t('navigation.about')}
        </LinkWrapper>
        <LinkWrapper className={styles.NavLink} to="/faqs/">
        {t('navigation.faqs')}
        </LinkWrapper>
        <LinkWrapper className={styles.NavLink} to="/case-study">
          {t('navigation.caseStudy')}
        </LinkWrapper>
        <LinkWrapper className={styles.NavLink} to="/clients/">
          {t('navigation.clients')}
        </LinkWrapper>
        <LinkWrapper className={styles.NavLink} to="/news/">
          {t('navigation.newsAndBlog')}
        </LinkWrapper>
        <button
          className={styles.ToggleNavButton}
          onClick={showNav ? onHideNav : onShowNav}
        >
          {showNav ? (
            <Icon a11yText="Close" type="close" width={24} height={24} />
          ) : (
            <Icon a11yText="Open Menu" type="menu" width={24} height={24} />
          )}
        </button>
      </div>
    </Container>
  )
}

Navigation.propTypes = {
  onHideNav: func,
  onShowNav: func,
  showNav: bool,
  siteTitle: string,
  logo: object,
  id: string,
  hideBrandingBg: bool
}

export default Navigation

export const LinkWrapper = ({ children, to, className, textClassName, highlight, ...other }) => (
  <SmartLink
    className={classnames(className, highlight && styles.highlight)}
    to={to}
    {...other}
  >
    <Type className={textClassName} as="span" size="menu">
      {children}
    </Type>
  </SmartLink>
)

LinkWrapper.propTypes = {
  children: node,
  to: string,
  className: string,
  highlight: string
}
